import * as ActionTypes from '../actions/types';
import delay from 'xstream/extra/delay';
import sampleCombine from 'xstream/extra/sampleCombine';
import GENERAL_FUNCTIONS from '../utils/functions/functions';
import HEADER_FUNCTIONS from '../utils/functions/headers';
import xs from 'xstream';
import * as actions from '../actions';
const REQUEST_FORM_TYPES = 'requestFormTypes';
const REQUEST_FORM_TYPES_BY_POLICY_AND_CATEGORY_CODE =
    'requestFormTypesByPolicyAndCategoryCode';

export function requestFormTypes(sources) {
    const state$ = sources.STATE;
    const token$ = state$.map(state => state.applicationUser.accessToken);

    const request$ = sources.ACTION.filter(
        action => action.type === ActionTypes.FETCH_FORM_TYPES,
    )
        .compose(delay())
        .compose(sampleCombine(token$))
        .map(([action, token]) => ({
            url: GENERAL_FUNCTIONS.getBaseURL() + 'api/FormType',
            headers: HEADER_FUNCTIONS.headersWithTokenJson(token),
            category: REQUEST_FORM_TYPES,
            method: 'GET',
        }));

    let httpResponse$ = sources.HTTP.select(REQUEST_FORM_TYPES)
        .map(response => response.replaceError(err => xs.of(err)))
        .flatten()
        .map(response =>
            response.status === 200
                ? actions.fetchFormTypesSuccess(response)
                : actions.fetchFormTypesFailed(response),
        );

    return {
        ACTION: httpResponse$,
        HTTP: request$,
    };
}

export function requestQuestionGroupStepsWhenFormTypesAreEmpty(sources) {
    const state$ = sources.STATE;
    const answers$ = state$.map(state => state.answer.answer);

    const action$ = sources.ACTION.filter(
        action =>
            action.type ===
            ActionTypes.FETCH_FORM_TYPES_BY_POLICY_AND_CATEGORY_CODE_SUCCESS,
    )
        .filter(action => action.payload && !action.payload.body.data)
        .compose(sampleCombine(answers$))
        .map(([action, answers]) =>
            actions.fetchQuestionGroupStepByPolicyTypeAndClaimCategoryAndClaimType(
                {
                    policyTypeCode: answers.policyType,
                    claimCategoryCode: answers.claimCategory,
                    formTypeCode: '___',
                },
            ),
        );
    return {
        ACTION: action$,
    };
}

export function requestClaimFormTypesByPolicyAndCategoryCode(sources) {
    const state$ = sources.STATE;
    const token$ = state$.map(state => state.applicationUser.accessToken);

    const request$ = sources.ACTION.filter(
        action =>
            action.type ===
            ActionTypes.FETCH_FORM_TYPES_BY_POLICY_AND_CATEGORY_CODE,
    )
        .compose(delay())
        .compose(sampleCombine(token$))
        .map(([action, token]) => ({
            url:
                GENERAL_FUNCTIONS.getBaseURL() +
                `api/FormType/PolicyTypeCode/${action.payload.policyTypeCode}/ClaimCategoryCode/${action.payload.claimCategoryCode}/claimApplication`,
            headers: HEADER_FUNCTIONS.headersWithTokenJson(token),
            category: REQUEST_FORM_TYPES_BY_POLICY_AND_CATEGORY_CODE,
            method: 'GET',
        }));

    let httpResponse$ = sources.HTTP.select(
        REQUEST_FORM_TYPES_BY_POLICY_AND_CATEGORY_CODE,
    )
        .map(response => response.replaceError(err => xs.of(err)))
        .flatten()
        .map(response =>
            response.status === 200
                ? actions.fetchFormTypesByPolicyAndCategoryCodeSuccess(response)
                : actions.fetchFormTypesByPolicyAndCategoryCodeFailed(response),
        );

    return {
        ACTION: httpResponse$,
        HTTP: request$,
    };
}
